import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'w-full sm:mt-8',
    header: 'mb-3 flex justify-between gap-1 max-sm:mb-4 sm:mb-4',
    subHeader: 'mb-4 flex justify-between gap-1 max-sm:flex-col sm:mb-12',
    author: 'heading-l-strikethrough flex w-full items-center justify-between',
    date: 'heading-xs text-text-inactive',
    authorInfo: 'heading-xs',
    content: 'flex flex-col gap-6',
    gallery: 'mb-4',
    imageButton: 'size-16 cursor-pointer',
    image: 'size-16 object-cover',
    carousel: '[--slide-size:auto] [--slide-spacing:4px]',
    service: 'mt-6 h-5 w-auto',
    sourceLink: ''
  }
});
